import { NgModule} from '@angular/core';
import { CommonModule} from '@angular/common';
import { RouterModule} from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { ConfirmationModalModule } from '../confirmation-modal/confirmaton-modal.module';
import { FaIconLibrary, FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faSync, faTimesCircle } from '@fortawesome/free-solid-svg-icons';

import { StreamCreatorComponent } from './stream-creator.component';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ImageEditorModule } from '../image-editor/image-editor.module';
import { AddressModule } from '../address/address.module';
import { CurrencyPriceModule } from '../directives/currency-price.module';
import { ToggleSwitchModule } from '../toggle-switch/toggle-switch.module';
import { InputTypeCounterModule } from '../directives/input-type-counter.module';
import { AlertMessageModule } from '../alert-message/alert-message.module';

@NgModule({
    declarations: [ StreamCreatorComponent ],
    imports: [
        RouterModule,
        CommonModule,
        FormsModule,
        ConfirmationModalModule,
        FontAwesomeModule,
        ImageEditorModule,
        AddressModule,
        ReactiveFormsModule,
        CurrencyPriceModule,
        ToggleSwitchModule,
        InputTypeCounterModule,
        AlertMessageModule
    ],
    providers: [
        NgbActiveModal
    ],
    exports: [ StreamCreatorComponent ]
})

export class StreamCreatorModule {
    constructor(library: FaIconLibrary) {
        library.addIcons(faSync, faTimesCircle);
    }
}
